import { getRequestConfig } from './index';

export const doCheckLicenceValidity = async (id: number): Promise<Response> => {
  const headers = getRequestConfig();
  return fetch(`/json/app/data/checklicense/${id}`,  {...headers, method: 'POST'});
};
